import FontAwesomeIcon from "../Icon";
import "./DownloadableAssetCard.scss";
import React from "react";

export const DownloadableAssetCard = ({ title, url }) => {
  const openInNewTab = () => window.open(url, "_blank", "noreferrer");
  return (
    <div className="dl-asset-card" onClick={openInNewTab}>
      <FontAwesomeIcon glyph="file-download" size={10} weight="solid" />
      <span>{title}</span>
    </div>
  );
};
